import { render, staticRenderFns } from "./tdorderSearch.vue?vue&type=template&id=40b3d1cb&scoped=true"
import script from "./tdorderSearch.vue?vue&type=script&lang=js"
export * from "./tdorderSearch.vue?vue&type=script&lang=js"
import style0 from "./tdorderSearch.vue?vue&type=style&index=0&id=40b3d1cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3d1cb",
  null
  
)

export default component.exports